<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :viewBox="`0 0 ${size} ${size}`"
    :width="size"
    :height="size"
    style="transform: rotate(0deg); width: 24px"
    :class="classes"
  >
    <circle
      fill="transparent"
      :cx="size / 2"
      :cy="size / 2"
      :r="radius"
      :stroke-width="width"
      :stroke-dasharray="strokeDashArray"
      :stroke-dashoffset="strokeDashOffset"
      class="bx-progress-circular-underlay"
    />
    <circle
      fill="transparent"
      :cx="size / 2"
      :cy="size / 2"
      :r="radius"
      :stroke-width="width"
      :stroke-dasharray="strokeDashArray"
      :stroke-dashoffset="strokeDashOffset"
      class="bx-progress-circular-overlay"
    />
  </svg>
</template>
<script>
export default {
  name: "bx-progress-circular",
  props: {
    size: {
      type: Number,
      default: 40
    },
    color: {
      type: String,
      default: "default"
    },
    value: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 10
    }
  },
  computed: {
    classes() {
      const classes = ["bx-progress-circular"];
      if (this.color) {
        classes.push(`bx-color-${this.color}`);
      }
      return classes;
    },
    radius() {
      return this.size / 2 - this.width / 2;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return parseFloat(this.value);
    },
    strokeDashOffset() {
      return ((100 - this.normalizedValue) / 100) * this.circumference + "px";
    }
  }
};
</script>
